import { render, staticRenderFns } from "./AdFloat.vue?vue&type=template&id=38e326c4&scoped=true"
import script from "./AdFloat.vue?vue&type=script&lang=js"
export * from "./AdFloat.vue?vue&type=script&lang=js"
import style0 from "./AdFloat.vue?vue&type=style&index=0&id=38e326c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e326c4",
  null
  
)

export default component.exports